import { Navigate } from "react-router";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import useFetch from "@entrilia/shared/hooks/useFetch";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import useClientContext from "../../../../context/useClientContext";
import FullHeightFlexPage from "../../../common/layout/FullHeightFlexPage";
import PortalWidgetSettingsPageContent from "./PortalWidgetSettingsPageContent";
import PortalWidgetSettingsPageHeader from "./PortalWidgetSettingsPageHeader";

const PortfolioWidgetSettingsPage = () => {
  usePageTitle("Portfolio");
  const { hasAnyPermission } = useClientContext();
  const [portalSettings, error, { setData: setPortalSettings }] = useFetch(adminApi.getInvestorPortalSettings);

  if (!hasAnyPermission(["ManageInvestorPortalSettings"])) {
    return <Navigate to=".." />;
  }

  if (error) {
    logError(error, "[PortfolioWidgetSettingsPage] getInvestorPortalSettings");
    return <DataLoadingFailed title="Failed to load page settings" />;
  }

  return (
    <FullHeightFlexPage>
      <PortalWidgetSettingsPageHeader
        title="Portfolio"
        page="PortfolioCompanies"
        portalSettings={portalSettings?.settings}
      />
      <PortalWidgetSettingsPageContent
        page="PortfolioCompanies"
        portalSettings={portalSettings?.settings}
        onPortalSettingsUpdated={setPortalSettings}
      />
    </FullHeightFlexPage>
  );
};

export default PortfolioWidgetSettingsPage;
